import { useState, useEffect } from 'preact/hooks';

export function useChatHistory(sharedToken) {
  const [messages, setMessages] = useState(() => {
    if (sharedToken) return [];
    try {
      const saved = localStorage.getItem('mta_chat_history');
      if (saved) {
        const parsed = JSON.parse(saved);
        return parsed.map((msg) => {
          const cleaned = { ...msg, pending: false, streaming: false, status: '' };
          if (!cleaned.panels) {
            cleaned.panels = [];
          }
          if (cleaned.map && !cleaned.panels.some((p) => p.type === 'map')) {
            cleaned.panels.push({ type: 'map', data: cleaned.map, id: `${cleaned.id}_map` });
          }
          delete cleaned.map;
          if (cleaned.tips && typeof cleaned.tips === 'object') {
            // A tips stream interrupted by a reload cannot be resumed: drop the partial
            // text so re-opening the panel requests the tips again.
            const wasRunning = cleaned.tips.pending || cleaned.tips.streaming;
            // History saved by older versions may hold the expert profile and progress messages
            // that name the expert: drop them.
            const { expert, status, ...tips } = cleaned.tips;
            cleaned.tips = {
              ...tips,
              pending: false,
              streaming: false,
              ...(wasRunning ? { content: '', error: null, empty: false } : {})
            };
          }
          return cleaned;
        });
      }
    } catch (e) { }
    return [];
  });

  useEffect(() => {
    try {
      if (!sharedToken && messages.length > 0) {
        localStorage.setItem('mta_chat_history', JSON.stringify(messages));
      }
    } catch (e) { }
  }, [messages, sharedToken]);

  return [messages, setMessages];
}
